const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white" role="contentinfo">
      <div className="container mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Column 1: About */}
          <div className="space-y-6">
            <div className="flex items-center space-x-4 mb-8">
              <div className="relative w-8 h-8">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 rounded-lg"></div>
                <img src="/inz-logo.png" alt="Logo" className="relative w-full h-full rounded-lg object-cover" />
              </div>
              <span className="text-xl font-bold">InvizHer</span>
            </div>
            <p className="text-gray-400 mb-4">
              Exploring the world of programming and development through providing the thoughtful content.
            </p>
            <div className="flex space-x-4">
              <a href="https://youtube.com/@invizher" className="text-gray-400 hover:text-white transition-colors" aria-label="Visit our YouTube channel" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-youtube" aria-hidden="true"></i>
              </a>
              <a href="https://t.me/invizher" className="text-gray-400 hover:text-white transition-colors" aria-label="Join our Telegram channel" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-telegram" aria-hidden="true"></i>
              </a>
              <a href="https://www.instagram.com/invizher/" className="text-gray-400 hover:text-white transition-colors" aria-label="Follow us on Instagram" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-instagram" aria-hidden="true"></i>
              </a>
              <a href="https://github.com/PavanMagar" className="text-gray-400 hover:text-white transition-colors" aria-label="Visit our GitHub profile" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-github" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-400 hover:text-white transition-colors">Home</a></li>
              <li><a href="/posts" className="text-gray-400 hover:text-white transition-colors">Posts</a></li>
              <li><a href="/categories.html" className="text-gray-400 hover:text-white transition-colors">Categories</a></li>
            </ul>
          </div>

          {/* Column 3: Resources */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Resources</h3>
            <ul className="space-y-2">
              <li><a href="/pages/faq.html" className="text-gray-400 hover:text-white transition-colors">FAQ</a></li>
              <li><a href="/pages/privacy.html" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</a></li>
              <li><a href="/pages/terms.html" className="text-gray-400 hover:text-white transition-colors">Terms of Service</a></li>
            </ul>
          </div>

          {/* Column 4: Support */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              <li><a href="/pages/about.html" className="text-gray-400 hover:text-white transition-colors">About</a></li>
              <li><a href="/pages/contact.html" className="text-gray-400 hover:text-white transition-colors">Contact</a></li>
              <li><a href="/pages/contact.html" className="text-gray-400 hover:text-white transition-colors">Report Issue</a></li>
            </ul>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400">© 2024 InvizHer. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
